export default "__VITE_ASSET__Cux$e1V6__"